import { parseMskInstant } from './moscow-calendar-date';

/**
 * Отображение срока действия прокси: календарная дата + время по Москве
 * (совпадает с тем, как после продления хранится момент окончания — с «часом создания»).
 *
 * @param {string|Date|null|undefined} raw значение expires_at с API
 * @returns {string|null} null если пусто или не распарсилось
 */
export const formatProxyExpiresAtMskDisplay = (raw) => {
  if (raw == null || String(raw).trim() === '') {
    return null;
  }
  const d = parseMskInstant(raw);
  if (!d) {
    return null;
  }
  const datePart = new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(d);
  const timePart = new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(d);
  return `${datePart}, ${timePart} МСК`;
};

/**
 * Info-панель прокси: «17.06 в 13:07» (календарный день.месяц и время по Москве, без года и без «МСК»).
 *
 * @param {string|Date|null|undefined} raw
 * @returns {string|null}
 */
export const formatProxyExpiresAtInfoPanelCompact = (raw) => {
  if (raw == null || String(raw).trim() === '') {
    return null;
  }
  const d = parseMskInstant(raw);
  if (!d) {
    return null;
  }
  const parts = new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    day: '2-digit',
    month: '2-digit'
  }).formatToParts(d);
  const dd = parts.find((p) => p.type === 'day')?.value;
  const mm = parts.find((p) => p.type === 'month')?.value;
  if (!dd || !mm) {
    return null;
  }
  const timePart = new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(d);
  return `${dd}.${mm} в ${timePart}`;
};

/**
 * Хвост строки «Истекает» в info-панели: «30 дней», «сегодня», просрочено …
 *
 * @param {number|null} days
 * @returns {string}
 */
export const formatProxyExpiryRemainingCompact = (days) => {
  if (days === null || days === undefined) {
    return '';
  }
  if (days < 0) {
    return `Просрочено ${Math.abs(days)} дн.`;
  }
  if (days === 0) {
    return 'сегодня';
  }
  if (days === 1) {
    return '1 день';
  }
  if (days >= 2 && days <= 4) {
    return `${days} дня`;
  }
  return `${days} дней`;
};

/**
 * Только календарная дата по Москве (без времени) — для таблицы прокси и краткого отображения.
 *
 * @param {string|Date|null|undefined} raw
 * @returns {string|null}
 */
export const formatProxyExpiresAtDateOnly = (raw) => {
  if (raw == null || String(raw).trim() === '') {
    return null;
  }
  const d = parseMskInstant(raw);
  if (!d) {
    return null;
  }
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(d);
};

/** Только часы:минуты по МСК из created_at (подсказка при выборе даты срока). */
export const formatProxyCreatedTimeMskOnly = (raw) => {
  if (raw == null || String(raw).trim() === '') {
    return null;
  }
  const d = parseMskInstant(raw);
  if (!d) {
    return null;
  }
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(d);
};
